export default __webpack_public_path__ + "static/media/copy.b74813a9.svg";